// Some commments here
// donation it an object and donation.id & donation.title from danations data

const advertisements = [
  {
    id: "1",
    donation: {
      donationId: "1",
      donationTitle: "Masjid Donation",
    },
    poster: "https://i.ibb.co/HhpQxPw/Masjid-Donation.jpg",
  },
  {
    id: "2",
    donation: {
      donationId: "3",
      donationTitle: "Zakat Al Maal",
    },
    poster: "https://i.ibb.co/qY3psPF/Zakat-Al-Maal.jpg",
  },
  {
    id: "3",
    donation: {
      donationId: "6",
      donationTitle: "Madrasha Donation",
    },
    poster: "https://i.ibb.co/rZ297WB/Madrasa-Classes.jpg",
  },
  // {
  //   id: "4",
  //   donation: {
  //     donationId: "2",
  //     donationTitle: "Zakat Al Fitr",
  //   },
  //   poster: "https://i.ibb.co/CWZFnX3/zakat-al-fitr.jpg",
  // },
  // {
  //   id: "5",
  //   donation: {
  //     donationId: "4",
  //     donationTitle: "Massey Iftar Donation",
  //   },
  //   poster:
  //     "https://i.ibb.co/d5HXKK2/Whats-App-Image-2023-03-27-at-09-19-49.jpg",
  // },
  // {
  //   id: "6",
  //   donation: {
  //     donationId: "8",
  //     donationTitle: "Food Fund",
  //   },
  //   poster: " https://i.ibb.co/W6bwLsx/food-fund.jpg",
  // },
  // {
  //   id: "7",
  //   donation: {
  //     donationId: "7",
  //     donationTitle: "Biriyani Fund",
  //   },
  //   poster:
  //     "https://i.ibb.co/BZ1Fyc7/Whats-App-Image-2023-10-05-at-11-18-25.jpg",
  // },
  {
    id: "8",
    donation: {
      donationId: "8",
      donationTitle: "Food Fund",
    },
    poster: "https://i.ibb.co.com/ksDpxmFt/sadaqa-e-jariya.jpg",
  },
  {
    id: "9",
    donation: {
      donationId: "9",
      donationTitle: "Dawah",
    },
    poster: "https://i.ibb.co/KqhqgM7/Dawah.jpg",
  },
  // {
  //   id: "11",
  //   poster:
  //     "https://i.ibb.co/Kq4YykR/Whats-App-Image-2024-06-11-at-17-09-43-1.jpg",
  // },
  {
    id: "12",
    poster: "https://i.ibb.co.com/C5f4xPRJ/mar-family-night.jpg",
  },
  // {
  //   id: "13",
  //   poster: "https://i.ibb.co/jZh7FFvw/family-program.jpg",
  // },

  // {
  //   id: "13",

  //   poster:
  //     "https://i.ibb.co/DfMb15Hx/Whats-App-Image-2025-05-30-at-16-45-53.jpg",
  // },

  // {
  //   id: "7",
  //   donation: {
  //     donationId: "3",
  //     donationTitle: "Masjid Donation",
  //   },
  //   poster: "/images/posters/qadr_donation.jpg",
  // },
  // {
  //   id: "8",
  //   donation: {
  //     donationId: "5",
  //     donationTitle: "Our Masjid Iftar Program",
  //   },
  //   poster: "/images/posters/iftar_fund.jpg",
  // },
  // {
  //   id: "14",

  //   poster:
  //     "https://i.ibb.co.com/bFVf1SV/Whats-App-Image-2024-10-22-at-04-06-31.jpg",
  // },
  // {
  //   id: "15",

  //   poster:
  //     "https://i.ibb.co.com/r01cpLn/Whats-App-Image-2024-12-06-at-05-49-30.jpg",
  // },
];

export default advertisements;
